var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-lg md__btn-primary float-right",attrs:{"id":"business-add-contact"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('i',{staticClass:"el-icon-plus"})])
}
var staticRenderFns = []

export { render, staticRenderFns }